import api from './api';

export interface TipoMoneda {
    codigoMoneda?: number;
    tipoMoneda?: number;
    nombre?: string;
    simbolo?: string;
    descripcion?: string;
    [key: string]: any;
}

const tipoMonedaService = {
    // Obtiene todos los tipos de moneda desde GET /api/TipoMoneda
    getTiposMoneda: async (): Promise<TipoMoneda[]> => {
        try {
            const resp = await api.get('/api/TipoMoneda');
            const raw = resp?.data;
            
            // Intentar diferentes estructuras de respuesta
            const items: any[] = Array.isArray(raw?.items)
                ? raw.items
                : Array.isArray(raw)
                    ? raw
                    : Array.isArray(raw?.data)
                        ? raw.data
                        : [];
            
            if (!Array.isArray(items) || items.length === 0) {
                return [];
            }

            return items.map((item: any) => ({
                codigoMoneda: item.codigoMoneda ?? item.codMoneda ?? item.tipoMoneda ?? item.id,
                tipoMoneda: item.tipoMoneda ?? item.codigoMoneda ?? item.id,
                nombre: item.nombre ?? item.descripcion ?? item.name,
                simbolo: item.simbolo ?? item.symbol ?? item.sigla,
                descripcion: item.descripcion ?? item.nombre ?? item.description,
                ...item
            }));
        } catch (error) {
            console.error('Error al obtener tipos de moneda:', error);
            return [];
        }
    },

    // Obtiene un tipo de moneda por su código
    getTipoMonedaPorCodigo: async (codigoMoneda: number): Promise<TipoMoneda | null> => {
        try {
            const tipos = await tipoMonedaService.getTiposMoneda();
            return tipos.find(t => 
                (t.codigoMoneda && Number(t.codigoMoneda) === Number(codigoMoneda)) ||
                (t.tipoMoneda && Number(t.tipoMoneda) === Number(codigoMoneda))
            ) || null;
        } catch (error) {
            console.error(`Error al obtener tipo de moneda para código ${codigoMoneda}:`, error);
            return null;
        }
    }
};

export default tipoMonedaService;

